// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { AnalyticsDialogProps } from './AnalyticsDialog.tsx';

export type { AnalyticsDialogProps } from './AnalyticsDialog.tsx';

export const LazyAnalyticsDialog: LoadableType<AnalyticsDialogProps> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AnalyticsDialog" */ './AnalyticsDialog.tsx'))
			.AnalyticsDialog,
});
